module.exports = __webpack_public_path__ + "img/xiaotouming.b3ca0516.png";